import { DateTimeEdit } from '@powerportalspro/react-fluent';

export function DateEditMainSample() {
  return <DateTimeEdit columnName="ppp_anniversary" />;
}
